import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { HomeComponent } from './home/home.component';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { HttpClientModule } from '@angular/common/http';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NavbarComponent } from './home/navbar/navbar.component';
import { ProductsComponent } from './home/products/products.component';
import { InputProductComponent } from './home/input-product/input-product.component';
import { EditProductComponent } from './home/edit-product/edit-product.component';
import { LoadingScreenComponent } from './home/loading-screen/loading-screen.component';
import { OrdersComponent } from './home/orders/orders.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MAT_DATE_LOCALE, MatNativeDateModule, MatOptionModule} from "@angular/material/core";
import {MatSelectModule} from "@angular/material/select";
import { InputOrderComponent } from './home/input-order/input-order.component';
import {MatInputModule} from "@angular/material/input";
import {MatSelectSearchModule} from "mat-select-search";
import {MatAutocompleteModule} from "@angular/material/autocomplete";
import {MatPaginatorModule} from "@angular/material/paginator";
import {MatTableModule} from "@angular/material/table";
import { EditOrderComponent } from './home/edit-order/edit-order.component';
import { ProcessOrderComponent } from './home/process-order/process-order.component';
import {MatRadioModule} from "@angular/material/radio";
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { ChangePasswordComponent } from './home/change-password/change-password.component';
import { AngularSplitModule } from 'angular-split';

@NgModule({
    declarations: [
        AppComponent,
        HomeComponent,
        NavbarComponent,
        ProductsComponent,
        InputProductComponent,
        EditProductComponent,
        LoadingScreenComponent,
        LoginComponent,
        OrdersComponent,
        InputOrderComponent,
        InputOrderComponent,
        EditOrderComponent,
        ProcessOrderComponent,
        ChangePasswordComponent
    ],
  imports: [
    BrowserModule,
    HttpClientModule,
    FormsModule,
    NgbModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatNativeDateModule,
    MatSelectModule,
    MatOptionModule,
    MatInputModule,
    MatSelectSearchModule,
    MatAutocompleteModule,
    MatPaginatorModule,
    MatTableModule,
    MatRadioModule,
    MatSnackBarModule,
    AngularSplitModule,
  ],
  providers: [
    {provide: MAT_DATE_LOCALE, useValue: 'ro-RO'}
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
